export default __webpack_public_path__ + "static/media/bootballBanner.3f48bade.jpg";